import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { List, Collapse, Link, Grid, Tooltip } from '@mui/material';
import NavItem from './NavItem';
import { getActive } from '..';
import Iconify from '../../Iconify';

export function isExternalLink(path) {
  return typeof path === 'string' && (path.startsWith('http://') || path.startsWith('https://'));
}

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChildren: PropTypes.bool,
  isCollapse: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function NavList({ data, depth = 1, hasChildren = false, isCollapse = false, disabled = false }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const path = typeof data?.path === 'string' ? data.path : '';
  const active = getActive(path, pathname);
  const [open, setOpen] = useState(active);

  if (!data) return null;

  const handleClickItem = () => {
    if (!hasChildren && path) {
      navigate(path);
    }
    setOpen((prev) => !prev);
  };

  return (
    <>
      {isExternalLink(path) ? (
        <Link href={path} target="_blank" rel="noopener noreferrer" underline="none">
          <NavItem item={data} depth={depth} open={open} active={active} isCollapse={isCollapse} />
        </Link>
      ) : (
        <Tooltip title={disabled ? 'Esta seccion esta en desarrollo' : ''}>
          <Grid position="relative" data-cy={data?.cy}>
            <NavItem
              item={data}
              depth={depth}
              disabled={disabled}
              open={open}
              active={active}
              isCollapse={isCollapse}
              onClick={handleClickItem}
            />
            {disabled && (
              <Iconify sx={{ position: 'absolute', right: '10px', top: '10px' }} icon="material-symbols:lock" />
            )}
          </Grid>
        </Tooltip>
      )}

      {!isCollapse && hasChildren && Array.isArray(data?.children) && (
        <Collapse in={open} unmountOnExit>
          <List component="div" disablePadding>
            <NavSubList data={data.children} depth={depth} />
          </List>
        </Collapse>
      )}
    </>
  );
}

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
};

function NavSubList({ data, depth }) {
  if (!Array.isArray(data)) return null;

  return (
    <>
      {data.map((list, idx) => (
        <NavList
          key={`${list.title || 'item'}-${list.path || idx}`}
          data={list}
          depth={depth + 1}
          hasChildren={!!list.children}
        />
      ))}
    </>
  );
}
